/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerSingleUxExposuresRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetCustomerSingleUxExposuresResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getCustomerSingleUxExposures = (request: GetCustomerSingleUxExposuresRequest, options?: CashRequestOptions) => post<GetCustomerSingleUxExposuresRequest, GetCustomerSingleUxExposuresResponse>("/2.0/cash/get-customer-single-ux-exposures", request, {...options, rejectOnError: true })